import LinkBankAccountErrorModal from '#client/components/LinkBankAccountErrorModal';
import { UNIT_ERROR_MESSAGES } from '#client/utils/Plaid/createErrorObject';

/**
 * Handles error data and opens a modal if the error message matches a specific validation failure.
 * @param {object} errorData - The error data object containing a ZBError.
 * @param {Function} openModal - Function to open the modal.
 */
export const onOpenLinkBankAccountErrorModal = (errorData, openModal) => {
  const error = errorData?.error;

  if (error?.message === UNIT_ERROR_MESSAGES.NAME_VALIDATION_FAILS.message) {
    openModal({
      component: LinkBankAccountErrorModal,
      metadata: errorData?.metadata,
      owner: error?.extensions?.meta?.owners?.[0] ?? ''
    });
  }
};
